import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken, { getSessionToken } from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import {
  textAnalysisTemplate,
  EHQ_API_URL,
} from 'containers/TextAnalysis/Template'

const { source, userType, orderBy, orderDirection, toolName, collectionIndex } =
  textAnalysisTemplate
const URL = `${EHQ_API_URL}/contributions`

const axios = (extraParams: any = {}) => {
  const token =
    process.env.NODE_ENV === 'production' ? getSessionToken() : getToken()

  return AxiosInitializer({
    token,
    transformResConfig: false,
    paramsSerializerConfig: true,
    ...extraParams,
    tool: toolName,
  })
}

const defaultParams = {
  source,
  user_type: userType,
  sort: { [orderBy]: orderDirection },
}

const taURL = {
  getList: (queryParams: any) => {
    const defaultParams = {
      sort: { [orderBy]: orderDirection },
    }
    return axios().get(URL, {
      params: { ...defaultParams, ...queryParams },
    })
  },
  editSentiment: ({ id, source_id, sentiment }: any) => {
    const defaultParams = {
      source_id,
      user_type: userType,
      collection_index: collectionIndex,
    }
    const queryParams = {
      scope: {
        key: 'id',
        value: id,
      },
      data: {
        sentiment: { custom: sentiment, automated: sentiment.toUpperCase() },
      },
    }
    return axios().put('contributions', queryParams, {
      params: defaultParams,
    })
  },
  exportData: (queryParams: any) => {
    return axios().get('contributions/csv', {
      params: { ...defaultParams, ...queryParams },
    })
  },
}

const taListAPI = {
  getList: (params = {}) =>
    apiWrapper({
      endPoint: taURL.getList,
      params,
    }),
  editSentiment: (params = {}) =>
    apiWrapper({
      endPoint: taURL.editSentiment,
      params,
    }),
  exportData: (params = {}) =>
    apiWrapper({
      endPoint: taURL.exportData,
      params,
    }),
}

export { taURL }
export default taListAPI
